// extracted by mini-css-extract-plugin
module.exports = {"field":"SignUp_field__1eVjJ","input":"SignUp_input__2u_sD","checkbox":"SignUp_checkbox__YJ75u","createBtn":"SignUp_createBtn__3TTbP","productName":"SignUp_productName__1ObL_"};